const adminRoutes = [
    {
        path: '/admin',
        redirect: '/admin/resellers',
        component: () => import('@/views/Admin'),
        meta: { requiresAuth: true, checkUserRole: true },
        children: [
            {
                path: 'resellers',
                name: 'Admin Resellers',
                component: () => import('@/views/Admin/Resellers'),
            },
            {
                path: 'profiles',
                name: 'Admin Profiles',
                component: () => import('@/views/Admin/Profiles'),
            },

            {
                path: 'profiles/add',
                name: 'Admin Profiles Add',
                component: () => import('@/views/Admin/Profiles/AddProfile'),
            },

            {
                path: 'profiles/edit/:id',
                name: 'Admin Profiles Edit',
                component: () => import('@/views/Admin/Profiles/EditProfile'),
            },

            {
                path: 'profiles/:id/combine',
                name: 'Admin Profiles Combine',
                component: () => import('@/views/Admin/Profiles/Combine/CombineProfile'),
            },

            {
                path: 'resellers/add',
                name: 'Admin Resellers Add',
                component: () => import('@/views/Admin/Resellers/AddReseller'),
            },

            {
                path: 'payments',
                name: 'Admin Payments',
                component: () => import('@/views/Admin/Payments/Overview'),
            },

            {
                path: 'payments/:id',
                name: 'Admin Payment Details',
                component: () => import('@/views/Admin/Payments/Show'),
            },

            {
                path: 'requests',
                name: 'Admin Requests',
                component: () => import('@/views/Admin/Requests/Overview'),
            },
        ],
    },
];

export default adminRoutes;
